<template>
  <BField
    label="RFC"
    label-for="customer-rfc"
  >
    <BAutocomplete
      id="customer-rfc"
      ref="input"
      name="customer-rfc"
      placeholder="XAXX010101000"
      field="rfc"
      icon="fingerprint"
      :pattern="pattern"
      :value="receiverRfc"
      :data="customers"
      :loading="loading"
      :required="required"
      :disabled="disabled"
      open-on-focus
      @typing="getCustomers"
      @input="onInput"
      @select="onSelect"
    >
      <template slot-scope="props">
        <div class="columns is-multiline">
          <div class="column is-2">
            email:
          </div>
          <div class="column is-10">
            {{ props.option.email }}
          </div>
          <div class="column is-2">
            name
          </div>
          <div class="column is-10">
            {{ props.option.name }}
          </div>
          <div class="column is-2">
            RFC:
          </div>
          <div class="column is-10">
            {{ props.option.rfc }}
          </div>
        </div>
      </template>
    </BAutocomplete>
  </BField>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'SearcherByRFC',
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      pattern: '^[A-Z&Ñ]{3,4}[0-9]{2}(0[1-9]|1[012])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2}[0-9A]$',
    };
  },
  computed: mapState({
    receiverRfc: state => state.invoice.receiverRfc,
    customers: state => state.customers.list,
  }),
  watch: {
    receiverRfc() {
      this.checkHtmlValidity();
    },
  },
  methods: {
    checkHtmlValidity() {
      setTimeout(() => {
        if (this.$refs.input) this.$refs.input.checkHtml5Validity();
      }, 10);
    },
    onInput(value) {
      this.$store.commit('invoice/setValue', { accessor: 'receiverRfc', value: value.toUpperCase() });
      this.$store.commit('customers/setValue', { accessor: 'rfc', value: value.toUpperCase() });
    },
    getCustomers: debounce(async function getCustomers(rfc) {
      if (rfc.length > 3) {
        this.loading = true;

        try {
          await this.$store.dispatch('customers/getAll', { size: 50, page: 1, rfc });
        } catch (error) {
          // eslint-disable-next-line
          console.error(error);
        }

        this.loading = false;
      }
    }, 400),
    onSelect(option = {}) {
      if (option) {
        const {
          name,
          email,
          rfc,
          companyName,
          creditDays,
          creditLimit,
          debts,
          debtsExpired,
          id,
          zipCode,
          taxRegime,
        } = option;

        const Days = creditDays > 0 ? creditDays : 1;
        const expirationDate = moment().add(Days, 'days').toDate();

        this.$store.commit('customers/setValues', {
          name,
          email,
          rfc,
          companyName,
          creditDays,
          creditLimit,
          debts,
          debtsExpired,
          id,
        });

        this.$store.commit('users/setValues', {
          name,
          email,
          rfc,
          companyName,
        });

        this.$store.commit('invoice/setValues', {
          receiverName: companyName,
          receiverRfc: rfc,
          receiverZipCode: zipCode,
          receiverTaxRegime: taxRegime,
          'operation.expirationDate': expirationDate,
        });

        this.$emit('select', option);

        setTimeout(() => {
          this.$refs.input.checkHtml5Validity();
        }, 10);
      }
    },
  },
};
</script>

<style scoped>
.column {
  padding: 0.15rem 0.25rem;
}

#customer-rfc {
  text-transform: uppercase;
}
</style>
